import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ContractService } from '@app/features/contracts/contract-service';
import { Contract } from '@app/features/contracts/contract.model';
import {
  acceptedDocumentsMimeTypes,
  DocumentTag,
  DocumentTagAndId,
} from '@app/features/documents/document.model';
import { UploadDocumentButton } from '@app/features/documents/upload-document-button/upload-document-button';
import { createHateoasError } from '@app/shared/errors/error-modal/hateoas-error';
import { ErrorService } from '@app/shared/errors/error.service';
import { TextIcon } from '@app/shared/icons/text-icon/text-icon';
import { DocumentTagLabelPipe } from '../../documents/document-tag-label-pipe';
import { DocumentTagToTextIconPipe } from '../../documents/document-tag-to-text-icon-pipe';

@Component({
  selector: 'app-add-document-to-contract',
  imports: [UploadDocumentButton, TextIcon, DocumentTagToTextIconPipe, DocumentTagLabelPipe],
  templateUrl: './add-document-to-contract.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './add-document-to-contract.scss',
})
export class AddDocumentToContract {
  acceptedDocumentsMimeTypes = acceptedDocumentsMimeTypes;
  contractId = input.required<string>();
  tag = input.required<DocumentTag>();
  contractUpdated = output<Contract>();

  contractService = inject(ContractService);
  errorService = inject(ErrorService);

  onDocumentUploaded(documentId: string) {
    const tagAndId: DocumentTagAndId = { tag: this.tag(), id: documentId };
    this.contractService.addDocument(this.contractId(), tagAndId).subscribe({
      next: (updatedContract) => {
        this.contractUpdated.emit(updatedContract);
      },
      error: (err) => {
        console.error('Error adding document to contract', err);
        this.errorService.makeErrorMessage(
          createHateoasError("Erreur lors de l'ajout du document au contrat", {
            errors: [err],
          }),
        );
      },
    });
  }
}
